// datatable related plugins
import Breadcrumb from "components/Common/Breadcrumb";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  APPROVE_STATUS_P,
  APPROVE_STATUS_R,
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  TYPE_TRANSFER,
} from "constants/FormatDataContanst";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { TAX_DEDUCT_COMMON_FIELD } from "constants/TaxDeductRegisterReleaseConstant";
import { toastWarningIsAllStore, useQueryRouter } from "helpers/utils";
import jwt_decode from "jwt-decode";
import { KyHieuMauHoaDonMode } from "pages/GeneralInfo/InvoiceSymbol/utils";
import SendMailModal from "pages/IssueInvoice/modal/SendMailModal";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  deleteTaxDeductsRegistry,
  downloadXmlTaxDeductsRegistry,
  getListTaxDeductsRegistry,
  listInvoiceSymbol,
  releaseTaxDeductsRegistry,
  resetCreateTaxDeductsRegistry,
  resetDeleteTaxDeductsRegistry,
  resetDownloadXmlTaxDeductsRegistry,
  resetEditTaxDeductsRegistry,
  resetListTaxDeductsRegistry,
  resetReleaseTaxDeductsRegistry,
  setColumnVisibleTaxDeductsRegistry,
} from "store/actions";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_CUA_HANG,
  ROLE_EINVOICE_KE_TOAN,
} from "store/auth/login/actionTypes";
import {
  CREATE_TAX_DEDUCTS_REGISTRY_FAIL,
  CREATE_TAX_DEDUCTS_REGISTRY_SUCCESS,
  DELETE_TAX_DEDUCTS_REGISTRY_FAIL,
  DELETE_TAX_DEDUCTS_REGISTRY_SUCCESS,
  DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY_FAIL,
  DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY_SUCCESS,
  EDIT_TAX_DEDUCTS_REGISTRY_FAIL,
  EDIT_TAX_DEDUCTS_REGISTRY_SUCCESS,
} from "store/data-format/actionTypes";

import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import { getResourceIdXML } from "helpers/form_helper";
import ErrorReleaseModal from "pages/DataFormatInvoice/modal/ErrorReleaseModal";
import HistoryTransferModal from "pages/DataFormatInvoice/modal/HistoryTransferModal";
import DetailData from "./DetailData";
import { getInvoiceStatus } from "./helper/functionHelper";
import PDFViewModal from "./modal/PDFViewModal";
import SignHSMModal from "./modal/SignHSMModal";
import TypeSignDigitalModal from "./modal/TypeSignDigitalModal";
import { MODE_FORM, tableFormateDate } from "./utils";

const ListData = props => {
  const history = useHistory();
  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  // modalTypeSign
  const [transferData, setTransferData] = useState(null);
  const [modalTypeSign, setModalTypeSign] = useState(false);
  const toggleTypeSignModal = () => setModalTypeSign(!modalTypeSign);
  // modalUSB
  const [modalUSBSign, setModalUSBSign] = useState(false);
  const toggleUSBSignModal = () => setModalUSBSign(!modalUSBSign);
  // modalHSM
  const [modalHSMSign, setModalHSMSign] = useState(false);
  const toggleHSMSignModal = () => setModalHSMSign(!modalHSMSign);
  // modalErrorRelease
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);
  // modalHistoryTransfer
  const [idHistory, setIdHistory] = useState(null);
  const [modalHistoryTransfer, setModalHistoryTransfer] = useState(false);
  const toggleHistoryTransferModal = () =>
    setModalHistoryTransfer(!modalHistoryTransfer);
  // toggleSendMailModal
  const [modalSendMail, setModalSendMail] = useState(false);
  const toggleSendMailModal = () => setModalSendMail(!modalSendMail);
  const [mailData, setMailData] = useState({
    idInvoice: null,
    mailDefault: null,
  });
  // Release modal
  const [idRelease, setIdRelease] = useState(null);
  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);
  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [modalRelease, setModalRelease] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const toggleReleaseModal = () => setModalRelease(!modalRelease);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);
  const toggleViewDetailModal = () => setModalDetail(!modalDetail);
  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const dataFormat = useSelector(
    state => /** @type {any} */ (state).dataFormat
  );
  const { loading: loadingDelete } = dataFormat.deleteTaxDeductsRegistryData;
  const { fileDownload, fileDownloadName, type } = dataFormat;
  const { loading, listData, totalCount, columnsVisible, params } =
    dataFormat.taxDeductsRegistry;

  const { t, i18n } = useTranslation(["taxDeductRegister"]);

  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  useEffect(() => {
    setCommonStatus(getInvoiceStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  let query = useQueryRouter();

  useEffect(() => {
    switch (type) {
      case CREATE_TAX_DEDUCTS_REGISTRY_SUCCESS:
        addToast(t("form.submit.create.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        toggleViewDetailModal();
        dispatch(getListTaxDeductsRegistry(params));
        dispatch(resetCreateTaxDeductsRegistry());
        break;
      case CREATE_TAX_DEDUCTS_REGISTRY_FAIL:
        addToast(t("form.submit.create.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCreateTaxDeductsRegistry());
        break;

      case EDIT_TAX_DEDUCTS_REGISTRY_SUCCESS:
        addToast(t("form.submit.edit.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        toggleViewDetailModal();
        dispatch(getListTaxDeductsRegistry(params));
        dispatch(resetEditTaxDeductsRegistry());
        break;
      case EDIT_TAX_DEDUCTS_REGISTRY_FAIL:
        addToast(t("form.submit.edit.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetEditTaxDeductsRegistry());
        break;
      case DELETE_TAX_DEDUCTS_REGISTRY_SUCCESS:
        addToast(t("form.submit.delete.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmDeleteModal();
        dispatch(getListTaxDeductsRegistry(params));
        dispatch(resetDeleteTaxDeductsRegistry());
        break;
      case DELETE_TAX_DEDUCTS_REGISTRY_FAIL:
        addToast(t("form.submit.delete.error"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDeleteTaxDeductsRegistry());
        break;
      case DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY_SUCCESS: {
        if (!modalUSBSign) {
          if (fileDownload !== null) {
            const link = document.createElement("a");
            link.href = fileDownload;
            link.setAttribute("download", fileDownloadName);
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlTaxDeductsRegistry());
        break;
      }
      case DOWNLOAD_XML_TAX_DEDUCTS_REGISTRY_FAIL:
        if (!modalUSBSign) {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlTaxDeductsRegistry());
        break;
      default:
        break;
    }
  }, [type]);

  const Dashboard = useSelector(state => /** @type {any} */ (state).Dashboard);
  const { tenantCodeHeader, finalBuInfo, buStoreHeader } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      params.page = 1;
      if (query.get("report_id")) {
        params.columnFilter = {
          "filter[report_id]": query.get("report_id"),
        };
      }
      if (query.get("export_id")) {
        params.columnFilter = {
          "filter[export_id]": query.get("export_id"),
        };
      }
      dispatch(getListTaxDeductsRegistry(params));
    }
  }, [finalBuInfo]);

  // Action list chang tenantCode
  //   useEffect(() => {
  //     if (tenantCodeHeader) {
  //       params.page = 1;
  //       dispatch(getListTaxDeductsRegistry(params));
  //     }
  //   }, [tenantCodeHeader]);

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [isRoleStore, setIsRoleStore] = useState(false);
  const [isRoleAccountant, setIsRoleAccountant] = useState(false);

  useEffect(() => {
    initColumn(true);
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const roleUser = info["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
      setIsRoleAccountant(
        listRole.findIndex(item => item === ROLE_EINVOICE_KE_TOAN) !== -1
          ? true
          : false
      );
    }
    //
    const param = {
      isTaxDeduct: true,
      page: -1,
      columnFilter: {
        "filter[record_status]": "O",
        "filter[khmhdon]": KyHieuMauHoaDonMode.TAX_DEDUCT,
      },
    };
    dispatch(listInvoiceSymbol(param));
    //
    return () => {
      dispatch(resetListTaxDeductsRegistry());
    };
  }, []);

  const initColumn = (loadDefaultFilter = false) => {
    const columns = getInitColumns(loadDefaultFilter);
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of columns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(columns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      //   setDataDetail({
      //     content: row.content,
      //     file_name: row.file_name,
      //     process_upload_id: row.id,
      //     status: row.status,
      //   });
      setDataDetail({ id: row.id, mode: MODE_FORM.VIEW });
      toggleViewDetailModal();
    },
  };
  const showPdfById = (id, path) => {
    setDataViewDocument({
      id,
      path,
    });
    togglePdfViewModal();
  };

  const showSendMail = row => {
    setMailData({
      idInvoice: row.id,
      mailDefault: row.nnt_dctdtu,
    });
    toggleSendMailModal();
  };

  const listRowAction = [
    // {
    //   icon: <i className="bx bx-history font-size-18 text-success" />,
    //   text: "Lịch sử truyền nhận",
    //   onClick: row => {
    //     setIdHistory(row.id);
    //     toggleHistoryTransferModal();
    //   },
    // },
    {
      icon: <i className="bx bx-edit font-size-18 text-success" />,
      text: "Cập nhật",
      isShow: ![ALL_STORE, ALL_BU].includes(buStoreHeader),
      conditionVisible: {
        // ttchung_sctu: [null, "0"],
        auth_status: [AUTH_STATUS_NEW],
        // signing_date: [null],
      },
      onClick: row => {
        setDataDetail({ id: row.id, mode: MODE_FORM.EDIT });
        setIdRelease(row.id);
        toggleViewDetailModal();
      },
    },

    {
      icon: <i className="bx bx-download font-size-18 text-primary" />,
      isDropdown: true,
      classDropdown: "dropdown-menu-3",
      conditionVisible: {
        // auth_status: [AUTH_STATUS_APPROVE],
        resource_list: [],
      },
      listDropdown: [
        {
          text: "Phản hồi tiếp nhận (Mltdiep110)",
          icon: <i className="bx bxs-file text-primary" />,
          conditionVisible: {
            isHaveMltdiep110: ["TRUE"],
          },
          onClick: row => {
            const resource_id = getResourceIdXML(
              row.resource_list,
              "tct-response",
              "110"
            );
            if (resource_id) {
              dispatch(
                downloadXmlTaxDeductsRegistry(
                  resource_id,
                  `Mltdiep110_${row[TAX_DEDUCT_COMMON_FIELD.TEN.field]}`
                )
              );
            } else {
              addToast("Tải xuống thất bại", {
                appearance: "error",
                autoDismiss: true,
              });
            }
          },
        },
        {
          text: "Phản hồi phê duyệt (Mltdiep111)",
          icon: <i className="bx bxs-file text-info" />,
          conditionVisible: {
            isHaveMltdiep111: ["TRUE"],
          },
          onClick: row => {
            const resource_id = getResourceIdXML(
              row.resource_list,
              "tct-response",
              "111"
            );
            if (resource_id) {
              dispatch(
                downloadXmlTaxDeductsRegistry(
                  resource_id,
                  `Mltdiep111_${row[TAX_DEDUCT_COMMON_FIELD.TEN.field]}`
                )
              );
            } else {
              addToast("Tải xuống thất bại", {
                appearance: "error",
                autoDismiss: true,
              });
            }
          },
        },
        {
          text: "Tờ khai đã ký",
          icon: <i className="bx bxs-file text-success" />,
          conditionVisible: {
            isHaveSigned: ["TRUE"],
          },
          onClick: row => {
            const resource_id = getResourceIdXML(row.resource_list, "signed");
            if (resource_id) {
              dispatch(
                downloadXmlTaxDeductsRegistry(
                  resource_id,
                  `Signed_${row[TAX_DEDUCT_COMMON_FIELD.TEN.field]}`
                )
              );
            } else {
              addToast("Tải xuống thất bại", {
                appearance: "error",
                autoDismiss: true,
              });
            }
          },
        },
        {
          text: "Tờ khai chưa ký",
          icon: <i className="bx bxs-file text-default" />,
          conditionVisible: {
            isHaveRaw: ["TRUE"],
          },
          onClick: row => {
            const resource_id = getResourceIdXML(row.resource_list, "raw");
            if (resource_id) {
              dispatch(
                downloadXmlTaxDeductsRegistry(
                  resource_id,
                  `Raw_${row[TAX_DEDUCT_COMMON_FIELD.TEN.field]}`
                )
              );
            } else {
              addToast("Tải xuống thất bại", {
                appearance: "error",
                autoDismiss: true,
              });
            }
          },
        },
      ],
      text: "Download XML",
    },
    {
      icon: <i className="bx bx-trash text-danger" />,
      text: "Xóa bỏ",
      isShow: ![ALL_STORE, ALL_BU].includes(buStoreHeader),
      conditionVisible: {
        // ttchung_sctu: [null, "0"],
        auth_status: [AUTH_STATUS_NEW],
        // signing_date: [null],
      },
      onClick: row => {
        setDataViewDocument({
          id: row.id,
        });
        toggleConfirmDeleteModal();
      },
    },
    {
      icon: <i className="bx bx-send font-size-18 text-success" />,
      text: "Phát hành tờ đăng ký phát hành chứng từ khấu trừ khấu trừ",
      conditionVisible: {
        resource_id: [],
        auth_status: [AUTH_STATUS_NEW],
      },
      onClick: row => {
        if (toastWarningIsAllStore(addToast)) {
          return;
        }
        setTransferData({
          id: row.id,
          mst: row.mst,
          resource_id: getResourceIdXML(row.resource_list, "raw"),
          type: TYPE_TRANSFER.REGISTER,
        });
        toggleTypeSignModal();
      },
    },
    {
      icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
      isDropdown: true,
      classDropdown: "dropdown-menu-3",
      conditionVisible: {
        // auth_status: [AUTH_STATUS_APPROVE],
        resource_list: [],
      },
      listDropdown: [
        {
          text: "Phản hồi tiếp nhận (Mltdiep110)",
          icon: <i className="bx bxs-file-pdf text-primary" />,
          conditionVisible: {
            isHaveMltdiep110: ["TRUE"],
          },
          onClick: row => {
            showPdfById(row.id, "confirm-pdf");
          },
        },
        {
          text: "Phản hồi phê duyệt (Mltdiep111)",
          icon: <i className="bx bxs-file-pdf text-info" />,
          conditionVisible: {
            isHaveMltdiep111: ["TRUE"],
          },
          onClick: row => {
            showPdfById(row.id, "approve-pdf");
          },
        },
        {
          text: "Bản hiển thị tờ khai",
          icon: <i className="bx bxs-file-pdf text-default" />,
          conditionVisible: {
            isHaveRaw: ["TRUE"],
          },
          onClick: row => {
            showPdfById(row.id, "review-pdf");
          },
        },
      ],
      text: "Xem bản hiển thị",
    },
    {
      icon: <i className="bx bx-history text-success" />,
      text: "Lịch sử truyền nhận",
      onClick: row => {
        setIdHistory(row.id);
        toggleHistoryTransferModal();
      },
    },
    // {
    //   icon: <i className="bx bx-send font-size-18 text-success" />,
    //   text: "Phát hành tờ đăng ký phát hành chứng từ khấu trừ khấu trừ",
    //   conditionVisible: {
    //     auth_status: [AUTH_STATUS_NEW],
    //   },
    //   onClick: row => {
    //     setIdRelease(row.id);
    //     toggleReleaseModal();
    //   },
    // },
    // {
    //   icon: <i className="bx bx-mail-send text-success" />,
    //   text: "Gửi mail",
    //   conditionVisible: {
    //     resource_id: [],
    //   },
    //   onClick: row => {
    //     showSendMail(row);
    //   },
    // },
  ];

  const getAuthStatus = (status, id) => {
    let infoError = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Đã phát hành",
    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành",
  };

  const getSelectFilterApproveStatus = () => {
    const filter = {};
    let listFilter = [
      APPROVE_STATUS_M,
      APPROVE_STATUS_P,
      APPROVE_STATUS_A,
      APPROVE_STATUS_R,
    ];
    // if (isRoleAccountant) {
    //   listFilter = [APPROVE_STATUS_P, APPROVE_STATUS_A];
    // }
    for (const item of listFilter) {
      if (selectFilterApproveStatus[item]) {
        filter[item] = selectFilterApproveStatus[item];
      }
    }
    return filter;
  };

  const selectFilterApproveStatus = {
    [APPROVE_STATUS_M]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_M]?.text, // "Lưu tạm",
    [APPROVE_STATUS_P]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_P]?.text, // "Gửi chờ duyệt",
    [APPROVE_STATUS_A]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_A]?.text, // "Đã duyệt",
    [APPROVE_STATUS_R]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_R]?.text, // "Từ chối duyệt",
  };

  const getApproveStatus = row => {
    let status = row.approve_status;
    let note_deny = row?.approve_note?.workflowNote;
    let infoError = null;
    // if (status === APPROVE_STATUS_R) {
    //   infoError = (
    //     <i
    //       style={{ cursor: "pointer" }}
    //       title="Hiển thị lý do từ chối"
    //       className="font-size-17 bx bx-info-circle text-danger"
    //       onClick={() => {
    //         setNoteReject(note_deny);
    //         toggleRejectModal();
    //       }}
    //     ></i>
    //   );
    // }
    return (
      <React.Fragment>
        <div className="d-flex gap-1" title={note_deny}>
          <Badge
            className={`font-size-12 ${commonStatus?.APPROVE_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.APPROVE_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const getInitColumns = (loadDefaultFilter = false) => {
    const initColumns = [
      {
        dataField: "id",
        text: "Id",
        sort: true,
        hidden: true,
        filter: textFilter({
          placeholder: t("placeholder.enter"),
        }),
      },
      {
        dataField: "bu_code",
        text: "Mã đơn vị",
        sort: true,
      },
      {
        dataField: "tnnt",
        text: t("form.tnnt"),
        sort: true,
        filter: textFilter({
          style: { maxWidth: "120px" },
          placeholder: t("placeholder.enter"),
        }),
      },
      {
        dataField: "mst",
        text: t("form.mst"),
        sort: true,
        filter: textFilter({
          style: { maxWidth: "120px" },
          placeholder: t("placeholder.enter"),
        }),
      },
      {
        dataField: "auth_status",
        text: t("auth_status.name"),
        hidden: false,
        formatter: (cellContent, row) => getAuthStatus(row.auth_status, row.id),
        filter: selectFilter({
          style: { maxWidth: "120px" },
          placeholder: t("placeholder.select"),
          options: selectFilterAuthStatus,
        }),
      },
      {
        dataField: "nlap",
        text: "Ngày lập",
        formatter: (cellContent, row) => tableFormateDate(row.nlap, false),
        filter: customFilter({
          type: CUSTOM_DATE_FILTER_TABLE_TYPE,
        }),
        filterRenderer: (onFilter, column) => (
          <CustomDateFilter
            onFilter={onFilter}
            column={column}
            paramFilter={params.columnFilter}
          />
        ),
      },
      {
        dataField: "mcqtqly",
        text: t("form.mcqtqly"),
        sort: true,
        filter: textFilter({
          style: { maxWidth: "120px" },
          placeholder: t("placeholder.enter"),
        }),
      },
      {
        dataField: "nlhe",
        text: t("form.nlhe"),
        sort: true,
        filter: textFilter({
          style: { maxWidth: "120px" },
          placeholder: t("placeholder.enter"),
        }),
      },
      {
        dataField: "dchi",
        text: t("form.dchi"),
        sort: true,
        filter: textFilter({
          style: { maxWidth: "120px" },
          placeholder: t("placeholder.enter"),
        }),
      },
      {
        dataField: "sdthoai",
        text: t("form.sdthoai"),
        sort: true,
        filter: textFilter({
          style: { maxWidth: "120px" },
          placeholder: t("placeholder.enter"),
        }),
      },
    ];
    return initColumns;
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getListTaxDeductsRegistry(params));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getListTaxDeductsRegistry(params));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleTaxDeductsRegistry(field, value));
  };

  return (
    <React.Fragment>
      {/* ErrorReleaseModal */}
      <ErrorReleaseModal
        isOpen={modalErrorRelease}
        toggle={toggleErrorReleaseModal}
        id={idRelease}
        path={"registry-tax-deducts"}
      />
      {/* History TransferModal */}
      <HistoryTransferModal
        isOpen={modalHistoryTransfer}
        toggle={toggleHistoryTransferModal}
        id={idHistory}
        path={"registry-tax-deducts"}
      />
      <DetailData
        dataDetail={dataDetail}
        isOpen={modalDetail}
        t={t}
        i18n={i18n}
        toggleReleaseModal={toggleReleaseModal}
        toggle={toggleViewDetailModal}
      />
      {/* Hình thức ký modal */}
      <TypeSignDigitalModal
        t={t}
        isOpen={modalTypeSign}
        downloadXmlFunc={downloadXmlTaxDeductsRegistry}
        transferData={transferData}
        toggle={toggleTypeSignModal}
        toggleUSBSignModal={toggleUSBSignModal}
        toggleHSMSignModal={toggleHSMSignModal}
      />
      <div className="page-content">
        <MetaTags>
          <title>{t("tax_deduct_register")}</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumb
            title=""
            breadcrumbItem={t("tax_deduct_register") + ` (${totalCount})`}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    {/* Deny modal */}
                    <ConfirmModal
                      isOpen={modalConfirmDelete}
                      titleHeader={
                        "Xác nhận xóa tờ đăng ký phát hành chứng từ khấu trừ"
                      }
                      titleBody={
                        "Hệ thống sẽ thực hiện xóa tờ đăng ký phát hành chứng từ khấu trừ này ?"
                      }
                      isDisableButton={loadingDelete}
                      onConfirm={note => {
                        dispatch(deleteTaxDeductsRegistry(dataViewDocument.id));
                      }}
                      textBtnConfirm={"Xác nhận"}
                      textBtnCancel={"Đóng"}
                      toggle={toggleConfirmDeleteModal}
                    />
                    {/* SendMailModal */}
                    <SendMailModal
                      isOpen={modalSendMail}
                      mailData={mailData}
                      toggle={toggleSendMailModal}
                      path={"tax-deduct-details"}
                    ></SendMailModal>
                    {/* PDFViewModal */}
                    <PDFViewModal
                      isOpen={modalPdfView}
                      dataViewDocument={dataViewDocument}
                      toggle={togglePdfViewModal}
                    ></PDFViewModal>
                    {/* Ký HSM Modal */}
                    <SignHSMModal
                      t={t}
                      isOpen={modalHSMSign}
                      transferData={transferData}
                      resetDataFunc={getListTaxDeductsRegistry}
                      releaseFunc={releaseTaxDeductsRegistry}
                      resetReleaseFunc={resetReleaseTaxDeductsRegistry}
                      params={params}
                      toggle={toggleHSMSignModal}
                    />
                    <RemoteDataTable
                      keyField="id"
                      data={listData?.map(item => ({
                        ...item,
                        isHaveMltdiep110: item.resource_list.some(
                          item => item.mltdiep === "110"
                        )
                          ? "TRUE"
                          : "FALSE",
                        isHaveMltdiep111: item.resource_list.some(
                          item => item.mltdiep === "111"
                        )
                          ? "TRUE"
                          : "FALSE",
                        isHaveSigned: item.resource_list.some(
                          item => item.type === "signed"
                        )
                          ? "TRUE"
                          : "FALSE",
                        isHaveRaw: item.resource_list.some(
                          item => item.type === "raw"
                        )
                          ? "TRUE"
                          : "FALSE",
                      }))}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    >
                      {![ALL_STORE, ALL_BU].includes(buStoreHeader) && (
                        <Button
                          type="button"
                          color="primary"
                          className="me-2 btn-label"
                          onClick={() => {
                            // if (toastWarningIsAllStore(addToast)) {
                            //   return;
                            // }
                            setDataDetail({
                              mode: MODE_FORM.ADD,
                            });
                            toggleViewDetailModal();
                          }}
                        >
                          <i className="bx bx-plus label-icon" />
                          {t("button.add")}
                        </Button>
                      )}
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
